module.exports = __webpack_public_path__ + "img/02.0e4cac02.jpg";